import { useState } from 'react'
import { useNoticias } from '../hooks/useNoticias'
import { useAuth } from '../contexts/AuthContext'

const TIMES_NFL = [
  'ARI','ATL','BAL','BUF','CAR','CHI','CIN','CLE',
  'DAL','DEN','DET','GB','HOU','IND','JAX','KC',
  'LAC','LAR','LV','MIA','MIN','NE','NO','NYG',
  'NYJ','PHI','PIT','SEA','SF','TB','TEN','WSH'
]

function formatarData(isoString) {
  if (!isoString) return ''
  const d = new Date(isoString)
  const diff = Date.now() - d.getTime()
  const horas = Math.floor(diff / (1000 * 60 * 60))
  if (horas < 1) return 'Agora'
  if (horas < 24) return `${horas}h atrás`
  const dias = Math.floor(horas / 24)
  return `${dias}d atrás`
}

export default function Noticias() {
  const { usuario } = useAuth()
  const [timeFiltro, setTimeFiltro] = useState(usuario?.time_favorito || null)
  const { noticias, loading, erro } = useNoticias(timeFiltro)

  return (
    <div>
      <div style={s.banner}>
        <span>Notícias dos 32 times via ESPN · Atualizadas automaticamente</span>
      </div>

      <div style={s.sectionLabel}>Filtrar por time</div>
      <div style={s.filtros}>
        <button
          style={{ ...s.filtroBtn, ...(timeFiltro === null ? s.filtroBtnAtivo : {}) }}
          onClick={() => setTimeFiltro(null)}
        >
          Todos
        </button>
        {TIMES_NFL.map(t => (
          <button
            key={t}
            style={{ ...s.filtroBtn, ...(timeFiltro === t ? s.filtroBtnAtivo : {}) }}
            onClick={() => setTimeFiltro(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {loading && <div style={s.loading}>Carregando notícias...</div>}
      {erro && <div style={s.erro}>{erro}</div>}

      {!loading && !erro && noticias.length === 0 && (
        <div style={s.loading}>Nenhuma notícia encontrada.</div>
      )}

      <div style={s.lista}>
        {noticias.map((noticia, i) => (
          <a
            key={i}
            href={noticia.link}
            target="_blank"
            rel="noopener noreferrer"
            style={s.card}
          >
            {noticia.imagem && (
              <img src={noticia.imagem} alt="" style={s.img} />
            )}
            <div style={s.cardBody}>
              {noticia.time && (
                <span style={s.teamTag}>{noticia.time}</span>
              )}
              <div style={s.titulo}>{noticia.titulo}</div>
              {noticia.descricao && (
                <div style={s.desc}>{noticia.descricao}</div>
              )}
              <div style={s.meta}>
                {formatarData(noticia.publicado_em)} · ESPN
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  )
}

const s = {
  banner: { background: '#EAF3F8', border: '0.5px solid #378ADD', borderRadius: 8, padding: '8px 12px', marginBottom: '.9rem', fontSize: 12, color: '#1A5C9A' },
  sectionLabel: { fontSize: 11, fontWeight: 500, color: '#888', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 7 },
  filtros: { display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: '.9rem' },
  filtroBtn: { fontSize: 11, padding: '4px 9px', borderRadius: 99, border: '0.5px solid #ddd', background: 'white', color: '#666', cursor: 'pointer', outline: 'none' },
  filtroBtnAtivo: { background: '#D85A30', color: 'white', border: '0.5px solid #D85A30' },
  loading: { fontSize: 13, color: '#888', padding: '1.5rem 0', textAlign: 'center' },
  erro: { background: '#FCEBEB', color: '#A32D2D', fontSize: 13, padding: '8px 12px', borderRadius: 8, marginBottom: '1rem' },
  lista: { display: 'flex', flexDirection: 'column', gap: 7 },
  card: { background: 'white', border: '0.5px solid #e0e0e0', borderRadius: 10, overflow: 'hidden', textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column' },
  img: { width: '100%', height: 160, objectFit: 'cover' },
  cardBody: { padding: '11px 13px' },
  teamTag: { fontSize: 10, fontWeight: 500, color: '#993C1D', background: '#FAECE7', borderRadius: 99, padding: '2px 7px', display: 'inline-block', marginBottom: 4 },
  titulo: { fontSize: 13, fontWeight: 500, lineHeight: 1.4, marginBottom: 3 },
  desc: { fontSize: 12, color: '#666', lineHeight: 1.4, marginBottom: 4, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' },
  meta: { fontSize: 11, color: '#999' },
}
